import { createContext, ReactNode } from 'react';

//TODO: this might need to be refactored because all the components are imported first before being used

export type ModalType = ReactNode | null;

export interface ModalContextValues {
    Modal: ModalType;
    setModal: (modal: ModalType) => void;
    loading: boolean;
    setLoading: (loading: boolean) => void;
}

export const ModalContext = createContext<ModalContextValues>({
    Modal: null,
    setModal: () => {},
    loading: false,
    setLoading: () => {},
});
